// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2zapx","emails":"CreateEditClinics_emails__2k1Th","emailTagLabel":"CreateEditClinics_emailTagLabel__-ighe"};